import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import { ReportTable } from '../components/reportTable';
import { getDataSource } from '../api/ds';
import { Typography, Button, Dialog, TextField, Divider, Checkbox, Card } from '@mui/material';
import { colors } from '../styles/colors';
import useOn from 'components/socketLib/UseOn';
import { useDataContextDeal } from 'actions/contextDealClient';
import { useNavigate, unstable_usePrompt as usePrompt } from 'react-router-dom';
import { DateMenu } from 'components/RangeDate';
import { get, post } from 'api/apiBridges/httpBridge';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import usePreventDoubleClick from 'components/AntiDBC';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { MarketClientSelector } from 'store/slices/marketClient';
import { useLocalNotifications } from 'components/Events';
import { SelectProductTocopy } from 'components/EIComponents/ProductInfo';
import CountProducts from 'components/widgets/countProducts';
import Loading from 'components/Load';
import _ from 'lodash';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import Scrollbars from 'rc-scrollbars';
import ClassicSearch from 'components/classicSearch';
import { ImgMagazine, SelectMarketLocal } from 'components/SelectMarket';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { getTMPVersion } from 'components/TechSpecif';
import { t } from 'i18next';
import { getNextItem } from 'utils/formatters';
import { TextInputDesign } from 'components/EIComponents/LittleComponents';
import { ShowModal } from 'components/Modal';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { sortProducts } from 'utils/globalSorts';
import { hoverStyle } from "styles/main";

// поставки по клиентам 
export function DeliveryClientStorage() {
    // Состояние, указывающее, есть ли несохраненные изменения в форме
    const [isFormDirty, setIsFormDirty] = useState(false);
    // Флаг для перехода на другую страницу после успешной операции
    const [shouldNavigate, setShouldNavigate] = useState(false);
    // Данные
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [contextProducts, setContextProducts] = useState([]);
     // Количество тюков
    const [countBale, setCountBale] = useState(1);
    // склад фулы и склад маркета
    const [warehouse_tranzit, setwarehouse_tranzit] = useState("");
    const [warehouse_market, setWarehouse_market] = useState("");
    // дата отгрузки
    const [date_shipment, setDate_shipment] = useState(new Date());
    // состояние ошибки, если пользователь напортачил
    const [error, setError] = useState(false);
    // Состояние для открытия модального окна добавления товара
    const [open, setOpen] = useState(false);
    const [openCopy, setOpenCopy] = useState(false);
    /** @type {[any, Function]} */
    const [copyData, setCopyData] = useState(undefined)
    // Навигационный хук из React
    const navigate = useNavigate();

    const { market } = useSelector(MarketClientSelector);

    const [oldMarket, setOldMarket] = useState(market);
    const [newMarket, setNewMarket] = useState(market);

    const { socket } = useContext(SocketContext);

    const [loading, setLoading] = useState(true);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [dist, setDist] = useState({});

    const [MW, setMW] = useState(undefined);


    // получаем дескриптор
    const ds = useMemo(() => getDataSource('dealClient'), []);
    // получаем контекст с выбранными товарами
    /** @type {any} */
    const { dataContext, clearContextData } = useDataContextDeal();

    const { showNotification } = useLocalNotifications();

    const { company_id, user_id  } = useSelector(
        loginSelector
      );

    const preventDoubleClick = usePreventDoubleClick();

    // обновляем кол-во страниц, когда залились пдф файлы
    useOn('updateCountPages', ($data) => {
        console.log("updateCountPages", $data)
        if ($data) {
            const index = contextProducts.findIndex((el) => el.size.barcode === $data.size);
            console.log("index", index)
            if (index !== -1) {
                contextProducts[index].qrcode.count = $data.count;
                setContextProducts(JSON.parse(JSON.stringify(contextProducts)));
            }
        }
    });
     // Хук для предупреждения пользователя при попытке уйти со страницы с несохраненными изменениями
    usePrompt({
        message: 'У вас есть несохраненные изменения. Вы уверены, что хотите покинуть страницу?',
        when: isFormDirty,
    });

    // при необходимости перехода на другую страницу, если форма не заполнялась или сохранена
    useEffect(() => {
        if (shouldNavigate && !isFormDirty) {
            navigate('..', { relative: 'path', replace: true });
        }
    }, [shouldNavigate, isFormDirty, navigate]);

    //Основные необходимые данные
    useEffect(() => {
        const fetchData = async () => {

            try {
            setLoading(false);
            const responseData = await get('Deal/GetCliStorageProducts', {cid:user_id, market: newMarket});
            let tdist = {}
            responseData.map((el) => {
                let tmp = []
                Object.keys(el.distribution)
                .sort((a, b) => {if (a < b) {return -1;}if (a > b) {return 1;}return 0;})
                .map((deal) => {
                    let tmp2 = []
                    Object.keys(el.distribution[deal])
                    .map(((box) => {
                        tmp2.push({
                            deal, 
                            box, 
                            id:el.distribution[deal][box].id,
                            countProduct:el.distribution[deal][box].countProduct,
                            countEtimated:el.distribution[deal][box].countEtimated,
                            countProductHist:el.distribution[deal][box].countProductHist,
                            countDefect:el.distribution[deal][box].countDefect,
                            countDefectHist:el.distribution[deal][box].countDefectHist,
                            package:el.distribution[deal][box].package,
                            consumes:el.distribution[deal][box].consumes,
                            addit_cons:el.distribution[deal][box].addit_cons,
                        })
                    }))
                    tmp2.sort((a, b) => {if (a.count < b.count) {return 1;}if (a.count > b.count) {return -1;}return 0;})
                    let idx = tmp2.findIndex((el) => el.box === 0 || el.box === "0")
                    if ( idx > -1) {
                        const item = tmp2.splice(idx, 1)[0];
                        tmp2.splice(tmp2.length, 1, item);
                    }
                    console.log("tmp2", tmp2)
                    tmp = tmp.concat(tmp2)
                })
                tdist[el.id] = tmp
            })
            setData(responseData)
            setDist(tdist)
            console.log("start dist", tdist)
            counttest();
            } catch (err) {
            } finally {
            setLoading(false);
            }

            
        };   
        
        fetchData();
    // }, [market]); 
    }, []); 

    const loadTZ = async (list, useMain = true) => {
        let tmp = JSON.parse(JSON.stringify(list))
        await Promise.all(tmp.map( async (el) => {
            console.log("el", el)
            let tz = await get("techTask/getOnProduct", {bar: el.size.barcode, cid: user_id, market: newMarket})
            let TZV = useMain? 'main': el.size.techTask?.TZV || el.size.techTask?.version  || 'main' 
            let tmpVersions = {}
            if (tz.versions) {
                for (let vel of Object.keys(tz.versions)) {
                    if (!tz.versions[vel].hide || tz.versions[vel].verison === TZV) {
                        tmpVersions[vel] = tz.versions[vel]
                    }
                }
            }
            let ntz = {
                barcode: el.size.barcode,
                title: el.title,
                vendorCode: el.vendorCode,
                versions: tmpVersions,
                TZV,
                market: newMarket
            }
            console.log("ntz", ntz)
            // if (!ntz.versions[TZV]) {
            //     ntz.versions[TZV] = {
            //         text: el.size.techTask?.text || "",
            //         services: el.size.techTask?.services || [],
            //         print: el.size.techTask?.print || 'classic',
            //         comment: tz.comment || '',
            //     }
            // }
            el.size.techTask = ntz
        }))
        return tmp
    }
    
    const checkBarcodes = async ($data) => {
        let updateBarcodes = undefined
        //Аутаулизируем баркоды
        let list = await get("Barcode_search/getAccordanceBarcodes", {
            uid: user_id,
            list: JSON.stringify($data.map((el) => el.size.barcode)),
            om: oldMarket,
            nm: newMarket
        })
        
        switch(newMarket) {
            case "wb": 
                updateBarcodes = await get("WBAPI/getProductByBarcode", {uid: user_id, bcs: JSON.stringify(list.map((el) => el.new))})
                break
            case "ozon": 
                updateBarcodes = await get("OZONAPI/getProductByBarcode", {uid: user_id, bcs: JSON.stringify(list.map((el) => el.new))})
                break
            case "custom": 
                updateBarcodes = await get("custom_product/getProductByBarcode", {uid: user_id, bcs: JSON.stringify(list.map((el) => el.new))})
                break
        }
        if (updateBarcodes && Object.keys(updateBarcodes).length !== $data.length) {
            let errList = []
            list.map((el) => {if (!updateBarcodes[el.new]) {errList.push(el.old)}})
            showNotification({
                id: 'No Analogs', 
                type: 'error', 
                message: `Не найдены аналоги на ${newMarket} для ${errList.join(', ')}` 
            });
            return {updateBarcodes:undefined, list}
        }
        return {updateBarcodes, list}

    }

    const loadBarcodes = async (list) => {
        let ub = await checkBarcodes(list)
        console.log("ub", ub)
        if (!ub.updateBarcodes) {
            setNewMarket(oldMarket)
            showNotification({
                id: 'Return market', 
                type: 'warning', 
                message: `Маркет изменен обратно на ${oldMarket}` 
            });
        }
        else {
            //Если же баркоды найдены, то мы получили фактически список новых товаров
            //Значит по идее, нам нужно сразу подгрузить 
            let tmp = await loadTZ(JSON.parse(JSON.stringify(Object.values(ub.updateBarcodes))))
            ub.list.map((el) => {
                //находим актуальный товар
                let idx1 = list.findIndex((fel) => fel.size.barcode===el.old)
                //Находим новый товр
                let idx2 = tmp.findIndex((fel) => fel.size.barcode===el.new)
                list[idx1].size.techTask = tmp[idx2].size.techTask
                list[idx1].size.newMarketBarcode = el.new
                list[idx1].newMarketProduct = tmp[idx2]
            })
            console.log("updatedTZ", tmp)
            setContextProducts(list);
        }
    }

    useEffect( () => {

        setLoading(true)
        const actualTZ = async () => {
            if (oldMarket !== newMarket) {
                await loadBarcodes(JSON.parse(JSON.stringify(contextProducts)))
            }
            //Это делается, чтобы при смене маркета обратно, подгрузилось правильное тз
            else {
                //Мы актуализируем список тз товара
                let res = await loadTZ(JSON.parse(JSON.stringify(contextProducts)))
                res.map((el => {delete el.size.newMarketBarcode}))
                //Устанавливаем список
                setContextProducts(res);
            }
            setLoading(false)
        }

        actualTZ()
        
    }, [newMarket]);

    // Обработка полученного из контекста
    useEffect( () => {

        const actualTZ = async (list) => {
            if (oldMarket !== newMarket) {
                loadBarcodes(JSON.parse(JSON.stringify(list)))
            }
            else {
                //Мы актуализируем список тз товара
                let res = await loadTZ(list, false)
                console.log("res", res)
                //Устанавливаем список
                setContextProducts(res);
            }
            counttest()
            clearContextData();
        }

        console.log("dataContext",dataContext)
        if (dataContext) {
            setIsFormDirty(true);
            // предобработка данных под формат, чтобы отображать в таблице и редактировать
            let tmp = JSON.parse(JSON.stringify(contextProducts))
            for (const el of dataContext.deal) {
                let idx = tmp.findIndex((fel) => fel.nmID === el.nmID && fel.size.barcode === el.size.barcode)
                if (idx === -1) {
                    el.size.inbox = el.inbox
                    el.totalStorage = el.storage_count
                    el.qrcode = { id: el.id, nmID: el.nmID, title: el.data.title, size: el.size, market: el.market, company: company_id, count: el.size.countQr, vendorCode: el.data.vendorCode};
                    tmp.push(el)
                }               
                else {
                    tmp[idx].countProduct += el.countProduct
                } 
            }
            // Добавляем данные к текущему состоянию
            setOldMarket(tmp[0].data.market)
            if (dataContext.multiWay) {
                setMW(dataContext.multiWay)
            }
            actualTZ(tmp)
        } else {
            // Если данных нет — возвращаемся на предыдущую страницу
            if (contextProducts.length === 0) {
                navigate('..', { relative: 'path', replace: true });
            }
        }
    }, [dataContext]);

    

    const create = async () => {
        if (contextProducts.length === 0) {
            showNotification({
                id: 'Null Products', 
                type: 'error', 
                message: 'Ни один товар не добавлен' 
            });
            return
        }        
        setLoadingCreate(true)
        let updateBarcodes = undefined
        if (oldMarket !== newMarket) {
            //Если маркеты различаются, то проверяем баркоды для нового маркета
            updateBarcodes = await checkBarcodes(JSON.parse(JSON.stringify(contextProducts)))
            //Если вернуло undefinded, значит не для всех товаров есть товары
            //Ошибку мы вадали прям в функции checkBarcodes, поэтому просто отменяем выполнение create
            if (!updateBarcodes.updateBarcodes) {
                setLoadingCreate(false)
                return
            }
        }


        //Тут можно взять только инфу, сколько всего товара у нас есть
        let tmp = JSON.parse(JSON.stringify(data));
        //Тут уже поинтереснее, тут информация, как товар распределен
        let tdist = JSON.parse(JSON.stringify(dist));

        let res = []
        let moveProducts = []
        let deletedBoxes = []
        let DL = []
        let BL = []
        let sku = 0;
        let units = 0
        //Начинаем мапиться по списку товаров
        await Promise.all(contextProducts.map(async (card) => {
            //Фактически на этом этапе мы получаем количество товара, которое хотим перетащить
            let count = parseInt(card.countProduct)

            //используем фор, так как map не позволяет делать break
            for (let i = 0; i < tdist[card.id].length; i++) {
                //Из распределения берем сделку и короб
                let DEAL = tdist[card.id][i].deal
                let BOX = tdist[card.id][i].box

                //Делаем действия если необходимое количество товара все еще больше нуля
                if (count > 0) {
                    if (tdist[card.id][i].countProduct > 0) {
                        //отмечаем короб и бокс, для которых нужно будет сделать пересчет количества
                        if (!DL.includes(DEAL)){DL.push(DEAL)}
                        if (!BL.includes(BOX)){BL.push(BOX)}

                        //Помечаем, что мы изменяли этот короб
                        tdist[card.id][i].edit = true

                        //Если в коробе больше товара, чем в нам нужно
                        if (tdist[card.id][i].countProduct > count) {
                            // Уменьшаем количество товара в этом коробе
                            tdist[card.id][i].countProduct -= count

                            //так как товара в коробе больше, чем было нужно, обнуляем count
                            count = 0
                        }
                        //В коробе меньше либо равно товара
                        else {
                            //убавляем количество товара, которое осталось взять
                            count -= tdist[card.id][i].countProduct

                            //Уменьшаем количество в распределении
                            tdist[card.id][i].countProduct = 0

                            //Если короб не нулевой, то говорим, что мы забрали из этого короба все товары этого типа
                            if (BOX !== "0")  {
                                let dbidx = deletedBoxes.findIndex((db) => db.BOX === BOX && db.DEAL === DEAL)
                                if ( dbidx === -1) {
                                    deletedBoxes.push({DEAL, BOX, list: [card.id]})
                                }
                                else {
                                    deletedBoxes[dbidx].list.push(card.id)
                                }
                            }

                        }
                    }
                } else break;
            }        
        })
        )
        //На данный момент в распределении изменены оставшиеся количества
        //Следовательно, что бы понять, что нужно удалить, а что оставить, нужно пройтись и сравнить сколько было и сколько осталось

        let mb = []

        //Собираем короба, которые можно переносить без изменений
        //В дальнейшем надо будет только пройтись по всем товарам из этих коробов и узнать, есть ли они в нулевом коробе
        //Для этого добавляем лист
        deletedBoxes.map((db) => {
            if (Object.values(tdist).flat().filter((fel) => fel.deal === db.DEAL && fel.box === db.BOX && fel.countProduct>0).length === 0) {
                mb.push({deal:db.DEAL, box: db.BOX, list:db.list})
                moveProducts.push(
                    {
                        deal:db.DEAL, 
                        box:db.BOX
                    }
                )
                Object.keys(tdist).map((k) => {
                    tdist[k] = tdist[k].filter((fel) => fel.box !== db.BOX || fel.deal !== db.DEAL)
                })
            }
        })


        //Оставляем только те короба, которые мы трогали
        //Эти короба нужно будет пересчитывать и определять как товары
        Object.keys(tdist).map((k) => {
            tdist[k] = tdist[k].filter((fel) => fel.edit)
        })

        //Следовательно, сейчас мы знаем
        //Список коробов, которые нужно переместить без изменения mb
        //список товаров и коробов из которых нужно вытащить какое-то количество с пересчетом tdist


        //Сначала нужно создать новую сделку, в который пойдет весь товар, который нужно пересчитывать

        //Создадим новую копию изначального распределения, чтобы правильно учитывать остатки в сделках
        let clearDist = JSON.parse(JSON.stringify(dist));

        //Для логов
        let logData = {}

        let updatingProducts = []

        let keys = Object.keys(tdist)
        for (let pid of keys){
            //находим такой товар в списке запрашиваемых
            let idx = contextProducts.findIndex((fel) => fel.id === pid)
            //Проверяем на всякий случай, что он найден, хотя по идее он не найден быть не может
            if (idx > -1) {
                //Копируем товар для новой сделки
                let obj = JSON.parse(JSON.stringify(contextProducts[idx]))

                let tmpCountProduct = 0
                
                //делаем пересчет для конкретного товара
                for (let db of tdist[pid]) {

                    //Получаем ind старого продукта из чистой копии распределения
                    let cdidx = clearDist[pid].findIndex((fel) => fel.box === db.box && fel.deal === db.deal)

                    //Количество товара, который пойдет в новую сделку
                    let countProductToNew = clearDist[pid][cdidx].countProduct - db.countProduct//Сколько было - сколько осталось

                    //Добавляем информацию для логов
                    if (logData[db.deal]) {
                        logData[db.deal].push({
                            deal_id:db.deal,
                            nmID:obj.nmID, 
                            barcode: obj.size.barcode, 
                            title: obj.data.title,
                            vendorCode: obj.vendorCode,
                            box:db.box,
                            count: countProductToNew
                        })
                    }
                    else {
                        logData[db.deal] = [{
                            deal_id:db.deal,
                            nmID:obj.nmID, 
                            barcode: obj.size.barcode, 
                            title: obj.data.title,
                            vendorCode: obj.vendorCode,
                            box:db.box,
                            count: countProductToNew
                        }]
                    }

                    //Добавляем в перемещаемый товар
                    moveProducts.push(
                        {
                            deal:db.deal, 
                            box:db.box, 
                            count:countProductToNew, 
                            product:{
                                nmID: obj.nmID, 
                                size: obj.size,
                                color: obj.color,
                                vendorCode: obj.vendorCode,
                                data: obj.data
                            }
                        }
                    )

                    //Добавляем количество, которое нужно будет засунуть в новую сделку
                    tmpCountProduct += countProductToNew

                    //Занашу их в отдельный список, чтобы обновить позднее, на случай, если возникнет косяк при создании сделки
                    updatingProducts.push(
                        {
                            pid:db.id, 
                            pr:obj.id,
                            deal_id:db.deal,
                            box: db.box,
                            data: {
                                countProduct:db.countProduct,//Указываем именно такое количество, так как столько осталось
                            }
                            //Будем обновлять через recalc, чтобы правильно пересчитались расходинки
                            // package: db.package,
                            // consumes: db.consumes,
                            // addit_cons: db.addit_cons
                        }
                    )
                }

                obj.countProduct = tmpCountProduct
                // удаляем эти поля, чтобы посчитались по новому тз
                // obj.package = tmpPackage
                // obj.consumes = tmpConsumes
                // obj.addit_cons = tmpAdditConsumes
                obj.countEtimated = 0
                obj.countProductHist = 0
                obj.countDefect = 0
                obj.countDefectHist = 0
                obj.box_id =  0
                obj.brand = obj.data.brand
                obj.photo = obj.data.photo
                obj.title = obj.data.title
                
                //Сохраняем установленное нами ранее тз
                let setedTZ = JSON.parse(JSON.stringify(obj.size.techTask))

                //Если переносится в другой маркет, то обновляем необходимые поля
                if (oldMarket !== newMarket) {
                    obj.nmID = obj.newMarketProduct.nmID
                    obj.vendorCode = obj.newMarketProduct.vendorCode
                    obj.brand = obj.newMarketProduct.brand
                    obj.title = obj.newMarketProduct.title
                    obj.photo = obj.newMarketProduct.photo
                    obj.material = obj.newMarketProduct.material
                    obj.color = obj.newMarketProduct.color
                    obj.dimensions = obj.newMarketProduct.dimensions
                    obj.size = obj.newMarketProduct.size
                }
                //Создаем новое тз
                let tz = {
                    text: setedTZ?.versions?.[setedTZ.TZV].text || undefined,
                    services: setedTZ?.versions?.[setedTZ.TZV].services || undefined,
                    print:setedTZ?.versions?.[setedTZ.TZV].print || undefined,
                    version: setedTZ.TZV
                }
                //Устанвливаем тз
                obj.size.techTask = tz

                delete obj.id
                delete obj.data
                delete obj.newMarketProduct
                res.push(obj)
                if (tmpCountProduct >0) {
                    sku += 1
                    units += tmpCountProduct
                }

            }
        }


        //Создаем новую сделку с товарами, которые переносятся не коробами
        const cli = await get('Clients/get', {cid:user_id});
        let ndid = await post('Deal/create', 
        {
            products: res, 
            count_bale: countBale, 
            warehouse_tranzit: warehouse_tranzit,
            warehouse_market: warehouse_market, 
            date_shipment: date_shipment, 
            id_company: company_id, 
            id_client: user_id, 
            id_manager: Number(cli.message.manager_id), 
            market: newMarket, 
            number_order: "", 
            status: 1, 
            type: "moving_deals",//Важно, так он попадает в раздел движения
            move_guide: moveProducts,
            old_market: oldMarket,
            data:{
                    sku,
                    units,
                    end_date:date_shipment,
                    // @ts-ignore
                    ...(MW && { MW }) // Добавляем MW только если оно не undefined
                }
        })
        if (ndid?.id) {
            //лог о создании сделки
            await post("Logs/create", {
                deal_id:ndid.id,
                user_type:"cli",
                user_id,
                type: "create_deal",
                data: {
                    sku,
                    units,
                    products: Object.values(logData).flatMap((arr) => arr)
                }
            })
            //лог для каждой сделки из которой ушли товары
            await Promise.all(Object.keys(logData).map(async (d) => {
                await post("Logs/create", {
                    deal_id:d,
                    user_type:"auto",
                    user_id: 0,
                    type: "move_product_to_deal",
                    data: {
                        newDeal: ndid.id,
                        products: logData[d]
                    }
                })
            }))

            //Создаем резервы сделок
            console.log("MP", moveProducts)
            const dfr = [...new Set(moveProducts.map(mp => mp.deal))];
            await Promise.all(dfr.map(async (d) => {
                await post("Deal/createDealReserv", {
                    did: d,
                    target_deal:ndid.id
                })
            }))

            let boxUpdateList = []

            let reculcList = {}
            
            //Обновление старых товаров
            let tmpdel = []
            //Их тз не меняется, так как это обновление информации для старой сделки
            for (let upp of updatingProducts) {
                if (upp.data.countProduct > 0) {
                    if (!reculcList[upp.pid]) {reculcList[upp.pid] = []}
                    reculcList[upp.pid].push(upp)
                    // await post("Deal/updateProductWithRecalc", upp)
                }
                else {
                    let idx = tmp.findIndex((fel) => fel.id === upp.pr)
                    
                    //Проверяем, есть ли такой товар в нулевом коробе
                    if (tmp[idx].distribution[upp.deal_id]['0']) {
                        //Обновляем его, изменяя только заявленное количество, так как забрали мы очевидно короб, в нулевом просто оставляемм отметку, что он был
                        //Используем обновление с пересчетом расходников
                        if (!reculcList[tmp[idx].distribution[upp.deal_id]['0'].id]) {
                            reculcList[tmp[idx].distribution[upp.deal_id]['0'].id] = []
                        }
                        reculcList[tmp[idx].distribution[upp.deal_id]['0'].id].push(
                            {
                                pid: tmp[idx].distribution[upp.deal_id]['0'].id, 
                                deal_id: upp.deal_id,
                                data: {
                                    countEtimated: tmp[idx].distribution[upp.deal_id]['0'].countEtimated + tmp[idx].distribution[upp.deal_id][upp.box].countEtimated,
                                    countProductHist: tmp[idx].distribution[upp.deal_id]['0'].countProductHist + tmp[idx].distribution[upp.deal_id][upp.box].countProductHist
                                }
                            }
                        )
                        // await post("Deal/updateProductWithRecalc", {
                        //     pid: tmp[idx].distribution[upp.deal_id]['0'].id, 
                        //     deal_id: upp.deal_id,
                        //     data: {
                        //         countEtimated: tmp[idx].distribution[upp.deal_id]['0'].countEtimated + tmp[idx].distribution[upp.deal_id][upp.box].countEtimated,
                        //         countProductHist: tmp[idx].distribution[upp.deal_id]['0'].countProductHist + tmp[idx].distribution[upp.deal_id][upp.box].countProductHist
                        //     }
                        //     }
                        // )
                        //Обновляем локально, чтобы если товар есть в нескольих коробах все отрабатывало првильно
                        tmp[idx].distribution[upp.deal_id]['0'].countEtimated += tmp[idx].distribution[upp.deal_id][upp.box].countEtimated
                        tmp[idx].distribution[upp.deal_id]['0'].countProductHist += tmp[idx].distribution[upp.deal_id][upp.box].countProductHist
                    }
                    else {
                        //Тут все немного интереснее
                        //так как нулевого товара не осталось, мы делаем копию товара, который уносим
                        //Значит нужно занулить количество и расходники
                        //Зануляем упаковку
                        let tmpPack = tmp[idx].distribution[upp.deal_id][upp.box].package
                        tmpPack.map((el) => {
                            if (el.fromDeal) {el.fromDeal = []}
                        })
                        //зануляем комплектацию
                        let tmpConsum = tmp[idx].distribution[upp.deal_id][upp.box].consumes
                        tmpConsum.map((el) => {
                            if (el.fromDeal) {el.fromDeal = []}
                        })
                        //зануляем расходники
                        let tmpAdditConsum = tmp[idx].distribution[upp.deal_id][upp.box].addit_cons
                        tmpAdditConsum.map((el) => {
                            if (el.fromDeal) {el.fromDeal = []}
                        })
                        //Товары копируются для старой сделки с нулевым количеством
                        let pr_copy = await post("products/copy", {
                            id:tmp[idx].distribution[upp.deal_id][upp.box].id, 
                            box_id:0,
                            countProduct:0, 
                            countEtimated:tmp[idx].distribution[upp.deal_id][upp.box].countEtimated,
                            countProductHist:tmp[idx].distribution[upp.deal_id][upp.box].countProductHist,
                            package: tmpPack,
                            consumes: tmpConsum,
                            addit_cons: tmpAdditConsum
                        })
                        //Обновляем локально, чтобы если товар есть в нескольих коробах все отрабатывало првильно
                        tmp[idx].distribution[upp.deal_id]['0'] = pr_copy
                    }
                    //Удаляем ненужный более товар 
                    // await post("products/delete", [upp.pid])
                    tmpdel.push(upp.pid)
                }
            }
            await post("products/delete", tmpdel)

            socket.emit('add_new_deal', {company_id, type: "moving_deals", id:ndid.id});
                    
            logData = {}

            //теперь работаем с переносом коробов в новую сделку
            for (let db of mb) {
                // Массив для хранения товаров, находящихся в текущем коробе
                // Будет использоваться для логирования
                let productsInBox = []

                //Для каждого короба проходимся по всем id товаров
                // for (let pr of db.list) {}
                await Promise.all(db.list.map(async (pr) => {
                    //получаем реальный товар, чтобы вытащить реальный id в базе данных
                    let idx = tmp.findIndex((fel) => fel.id === pr)

                    // Сохраняем информацию о товаре для логов
                    // Берем:
                    // - id из distribution (идентификатор конкретного перемещения)
                    // - title и barcode из самого товара tmp[idx]
                    let productDist = tmp[idx]?.distribution?.[db.deal]?.[db.box]

                    if (productDist?.id) {
                        productsInBox.push({
                            id: productDist.id, // id записи в распределении (важно для отслеживания)
                            title: tmp[idx]?.data?.title, // название товара
                            barcode: tmp[idx]?.size?.barcode, // штрихкод
                            count: productDist?.countProduct
                        })
                    }

                    //Проверяем нужно ли сохранять инфу в нулевом коробе
                    if (tmp[idx].distribution[db.deal][db.box].countEtimated > 0 ) {
                        //Если да, то проверям, есть ли этот товар в нулевом коробе
                        if (tmp[idx].distribution[db.deal]['0']) {
                            //Обновляем его, изменяя только заявленное количество, так как забрали мы очевидно короб, в нулевом просто оставляемм отметку, что он был
                            //Используем обновление с пересчетом расходников
                            if (!reculcList[tmp[idx].distribution[db.deal]['0'].id]) {
                                reculcList[tmp[idx].distribution[db.deal]['0'].id] = []
                            }
                            reculcList[tmp[idx].distribution[db.deal]['0'].id].push(
                                {
                                    pid: tmp[idx].distribution[db.deal]['0'].id, 
                                    deal_id: db.deal,
                                    data: {
                                        countEtimated: tmp[idx].distribution[db.deal]['0'].countEtimated + tmp[idx].distribution[db.deal][db.box].countEtimated,
                                        countProductHist: tmp[idx].distribution[db.deal]['0'].countProductHist + tmp[idx].distribution[db.deal][db.box].countProductHist
                                    }
                                }
                            )
                            // await post("Deal/updateProductWithRecalc", {
                            //     pid: tmp[idx].distribution[db.deal]['0'].id, 
                            //     deal_id: db.deal,
                            //     data: {
                            //         countEtimated: tmp[idx].distribution[db.deal]['0'].countEtimated + tmp[idx].distribution[db.deal][db.box].countEtimated,
                            //         countProductHist: tmp[idx].distribution[db.deal]['0'].countProductHist + tmp[idx].distribution[db.deal][db.box].countProductHist
                            //     }
                            //     }
                            // )
                            // await post("products/update", {
                            //     id:tmp[idx].distribution[db.deal]['0'].id, 
                            //     countEtimated: tmp[idx].distribution[db.deal]['0'].countEtimated + tmp[idx].distribution[db.deal][db.box].countEtimated,
                            //     countProductHist: tmp[idx].distribution[db.deal]['0'].countProductHist + tmp[idx].distribution[db.deal][db.box].countProductHist
                            //     }
                            // )
                            //Обновляем локально, чтобы если товар есть в нескольих коробах все отрабатывало првильно
                            tmp[idx].distribution[db.deal]['0'].countEtimated += tmp[idx].distribution[db.deal][db.box].countEtimated
                            tmp[idx].distribution[db.deal]['0'].countProductHist += tmp[idx].distribution[db.deal][db.box].countProductHist
                        }
                        else {
                            //Тут все немного интереснее
                            //так как нулевого товара не осталось, мы делаем копию товара, который уносим
                            //Значит нужно занулить количество и расходники
                            //Зануляем упаковку
                            let tmpPack = tmp[idx].distribution[db.deal][db.box].package
                            tmpPack.map((el) => {
                                if (el.fromDeal) {el.fromDeal = []}
                            })
                            //зануляем комплектацию
                            let tmpConsum = tmp[idx].distribution[db.deal][db.box].consumes
                            tmpConsum.map((el) => {
                                if (el.fromDeal) {el.fromDeal = []}
                            })
                            //зануляем расходники
                            let tmpAdditConsum = tmp[idx].distribution[db.deal][db.box].addit_cons
                            tmpAdditConsum.map((el) => {
                                if (el.fromDeal) {el.fromDeal = []}
                            })
                            //Товары копируются для старой сделки с нулевым количеством
                            let pr_copy = await post("products/copy", {
                                id:tmp[idx].distribution[db.deal][db.box].id, 
                                box_id:0,
                                countProduct:0, 
                                countEtimated:tmp[idx].distribution[db.deal][db.box].countEtimated,
                                countProductHist:tmp[idx].distribution[db.deal][db.box].countProductHist,
                                package: tmpPack,
                                consumes: tmpConsum,
                                addit_cons: tmpAdditConsum
                            })
                            //Обновляем локально, чтобы если товар есть в нескольих коробах все отрабатывало првильно
                            tmp[idx].distribution[db.deal]['0'] = pr_copy
                        }
                    }
                    //обновляем товар в переносимом коробе
                    //Делаем это после, чтобы правильно отработала копия

                    let obj = { 
                        deal_id:ndid.id,//Тут именно новая сделка
                        countEtimated: 0, 
                        countProductHist: 0,
                        countDefect: 0,
                        countDefectHist: 0,
                    }  
                    
                    //Сохраняем установленное нами ранее тз
                    //Но тут необходимо вытащить данное тз из установленных данных
                    //находим такой товар в списке запрашиваемых
                    //по id ищем idx товара
                    let cpidx = contextProducts.findIndex((fel) => fel.id === tmp[idx].id)
                    //Делаем копию тз
                    let setedTZ = JSON.parse(JSON.stringify(contextProducts[cpidx].size.techTask))

                    obj.size = JSON.parse(JSON.stringify(contextProducts[cpidx].size))
                    

                    if (oldMarket !== newMarket) {
                        obj.nmID = contextProducts[cpidx].newMarketProduct.nmID
                        obj.vendorCode = contextProducts[cpidx].newMarketProduct.vendorCode
                        obj.brand = contextProducts[cpidx].newMarketProduct.brand
                        obj.title = contextProducts[cpidx].newMarketProduct.title
                        obj.photo = contextProducts[cpidx].newMarketProduct.photo
                        obj.material = contextProducts[cpidx].newMarketProduct.material
                        obj.color = contextProducts[cpidx].newMarketProduct.color
                        obj.size = contextProducts[cpidx].newMarketProduct.size
                        obj.dimensions = contextProducts[cpidx].newMarketProduct.dimensions
                    }
                    //Создаем новое тз
                    let tz = {
                        text: setedTZ?.versions?.[setedTZ.TZV].text || undefined,
                        services: setedTZ?.versions?.[setedTZ.TZV].services || undefined,
                        print:setedTZ?.versions?.[setedTZ.TZV].print || undefined,
                        version: setedTZ.TZV
                    }
                    //Устанвливаем тз
                    obj.size.techTask = tz


                    //Поскольку у товара, который мы переносим, может измениться тз, то надо пересчитать расходники для этого товара
                    //Воспользуемся отдельной функцией на бэке, которая не просто обновит товар, а пересчитает расходники для этого товара, с учетом нового ТЗ

                    if (!reculcList[tmp[idx].distribution[db.deal][db.box].id]) {
                        reculcList[tmp[idx].distribution[db.deal][db.box].id] = []
                    }
                    reculcList[tmp[idx].distribution[db.deal][db.box].id].push(
                        {
                            pid:tmp[idx].distribution[db.deal][db.box].id, 
                            deal_id:db.deal,
                            data: obj
                        }
                    )
                    // await post("Deal/updateProductWithRecalc", {
                    //     pid:tmp[idx].distribution[db.deal][db.box].id, 
                    //     deal_id:db.deal,
                    //     data: obj
                    //     }
                    // )
                    // await post("products/update", obj)
                }))

                //Добавляем информацию для логов
                

                // Формируем объект для логов с товарами
                let logEntry = {
                    box: db.box,
                    // Добавляем массив товаров, которые были в коробе
                    products: productsInBox
                }

                if (logData[db.deal]) {
                    logData[db.deal].push(logEntry)
                }
                else {
                    logData[db.deal] = [logEntry]
                }

                boxUpdateList.push({id: db.box, deal_id:ndid.id, parent_id: null})
                // await post("Boxes/update", {id: db.box, deal_id:ndid.id, parent_id: null})
            }
            
            await post("Deal/updateProductWithRecalcList", {list: Object.values(reculcList)})

            // await Promise.all(boxUpdateList.map(async (el) => {
            //     await post("Boxes/update", el)
            // }))
            await post("Boxes/updateList", {list: boxUpdateList})

            //Информация о перенесенных коробах для новой сделки
            let movedBoxesList = []
            //лог для каждой сделки из которой ушли короба
            await Promise.all(Object.keys(logData).map(async (d) => {
                await post("Logs/create", {
                    deal_id:d,
                    user_type:"auto",
                    user_id: 0,
                    type: "move_box_to_deal",
                    data: {
                        newDeal: ndid.id,
                        boxes: logData[d]
                    }
                })
                movedBoxesList.push({deal: d, boxes: logData[d]})
            }))
            if (movedBoxesList.length > 0 ) {
                await post("Logs/create", {
                    deal_id:ndid.id,
                    user_type:"auto",
                    user_id: 0,
                    type: "move_box_from_deal",
                    data: {
                        list: movedBoxesList,
                        data: logData
                    }
                })
            }

            //Новую сделку тоже нужно пересчитать, после добавления коробов
            DL.push(ndid.id)
            
            // DL.map((did) => {post("Deal/recalcProducts", {did})})
            // BL.map((bid) => {post("Boxes/recalcProducts", {bid})})
            await post("Deal/recalcProductsMany", {dids: DL})
            await post("Boxes/recalcProductsMany", {bids: BL})

            setIsFormDirty(false);
            setShouldNavigate(true);
        }
        else {
            showNotification({
                id: 'createDealErr', 
                type: 'error', 
                message: 'Ошибка при создании сделки, сообщите администратору' 
            });
        }
        setLoadingCreate(false)
    }

    const changeRow = async ($data) => {
        console.log("$data", $data)
        if ($data.fk && $data.fk==='count') {
            let tmp = JSON.parse(JSON.stringify(contextProducts))
            const found = tmp.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                if ($data.count <= tmp[found].storage_count) {
                    tmp[found].countProduct = $data.count
                }
                else {
                    tmp[found].countProduct = tmp[found].storage_count
                    showNotification({
                        id: 'createDealErr', 
                        type: 'error', 
                        message: 'Вы попытались указать больше товара, чем есть на хранении' 
                    });
                }
                setContextProducts(tmp)
                
            }
        }
        else {
            changeTechText($data)
        }
        
    }

    // Обработка изменений технического задания
    const changeTechText = async ($data, noNotif = false) => {
        console.log("$data", $data)
        console.log("MARKET", newMarket)
        if ($data.swap) {
            const found = contextProducts.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                contextProducts[found].size.techTask.TZV = $data.swap
            }
            return
        }
        if (!$data.copy) {
            const found = contextProducts.findIndex((el) => String(el.id) === String($data.row.id))
            if (found !== -1) {
                //запоминаем матаданные
                const barcode = contextProducts[found].size.techTask?.barcode;
                const title = contextProducts[found].size.techTask?.title
                const vendorCode = contextProducts[found].size.techTask?.vendorCode
                
                //Проверяем, существовала ли ранее такая версия
                const isCreating = !contextProducts[found].size.techTask || (
                    !contextProducts[found].size.techTask.versions[$data.version]?.text &&
                    !contextProducts[found].size.techTask.versions[$data.version]?.services &&
                    !contextProducts[found].size.techTask.versions[$data.version]?.print
                )
                // Выполняем запрос на создание
                if (isCreating) {
                    await post('techTask/create', {
                        barcode: barcode,
                        client_id: user_id,
                        market:newMarket,
                        text: $data.text,
                        services: $data.services,
                        print: $data.print,
                        version: $data.version,
                        comment: $data.comment,
                        fbs: $data.fbs,
                        hide: $data.hide
                    });
                    if (!noNotif) {
                        showNotification({
                        id: 'fieldsErr', 
                        type: 'success', 
                        message: 'ТЗ успешно создано' 
                        });
                    }
                } 
                else {
                //Проверяем, нет ли уже существующих сделок с этим тз
                let useInDeals = await get('Deal/checkTZ', {
                    tz: $data.version, 
                    nmID: contextProducts[found].nmID,
                    barcode: contextProducts[found].size.barcode,
                    market:newMarket
                    }
                )
                //Но если обновлен только комментарий, то просто обновляем
                if (
                    useInDeals.message &&
                    ( 
                    $data.text !== contextProducts[found].size.techTask.versions[$data.version]?.text ||
                    // $data.services !== contextProducts[found].size.techTask.versions[$data.version]?.services ||
                    !_.isEqual($data.services, contextProducts[found].size.techTask.versions[$data.version]?.services) ||
                    $data.print !== contextProducts[found].size.techTask.versions[$data.version]?.print
                    )
                ) {
                    $data.version = `alt_${Object.keys(contextProducts[found].size.techTask.versions).length+1}`
                    await post('techTask/create', {
                        barcode: barcode,
                        client_id: user_id,
                        market:newMarket,
                        text: $data.text,
                        services: $data.services,
                        print: $data.print,
                        version: $data.version,
                        comment: $data.comment,
                        fbs: $data.fbs,
                        hide: $data.hide
                    });
                    showNotification({
                        id: 'fieldsErr', 
                        type: 'success', 
                        message: 'Альтернативаная версия ТЗ успешно создана' 
                    });
                }
                else {
                    await post('techTask/update', {
                        barcode: barcode,
                        client_id: user_id,
                        market:newMarket,
                        text: $data.text,
                        services: $data.services,
                        print: $data.print,
                        version: $data.version,
                        comment: $data.comment,
                        fbs: $data.fbs,
                        hide: $data.hide
                    });
                    showNotification({
                        id: 'fieldsErr', 
                        type: 'success', 
                        message: 'ТЗ успешно обновлено' 
                    });
                }
                }
                
                let updatedData = await get("techTask/getOnProduct", {bar: barcode, cid: user_id, market: newMarket})

                //Скрываем тз
                let tmpVersions = {}
                if (updatedData.versions) {
                    for (let vel of Object.keys(updatedData.versions)) {
                        if (!updatedData.versions[vel].hide || updatedData.versions[vel].verison === $data.version) {
                            tmpVersions[vel] = updatedData.versions[vel]
                        }
                    }
                }

                contextProducts[found].size.techTask = {
                    barcode: barcode,
                    title: title,
                    vendorCode:vendorCode,
                    versions: tmpVersions,
                    TZV: $data.version
                };

                setContextProducts(JSON.parse(JSON.stringify(contextProducts)));
            }
        }
        else {
            setCopyData(JSON.parse(JSON.stringify($data)))
            setOpenCopy(true)
        }
    }

    const copyTechTask = async (list) => {
        console.log(list)
        delete copyData.copy
        console.log("copyData", copyData)
        for (let el of list) {
            
            let versList = Object.keys(contextProducts.find((fel) => String(fel.id) === el).size.techTask.versions)
            await changeTechText({...copyData, version: getNextItem(versList), row: {id: el}}, true)
        }
        setCopyData(undefined)
        showNotification({
          id: 'succesCopy', 
          type: 'success', 
          message: 'ТЗ успешно скопировано' 
        });
    }

    const [allSKU, setAllSKU] = useState(0)
    const [allProduct, setAllProduct] = useState(0)

    const counttest = () =>{
        console.log("test", contextProducts)
        let allsku = 0
        let allproduct = 0
        if (contextProducts && contextProducts.length > 0){
            allsku = contextProducts.length
            for(let i = 0 ; i < contextProducts.length ; i++){
                allproduct += contextProducts[i].countProduct;
            }

            console.log('COUNT SKU', allsku);
            console.log('COUNT PRODUCT', allproduct);
        }
        
        setAllSKU(allsku)
        setAllProduct(allproduct)
    }

    useEffect(() => {
        counttest()
    }, [contextProducts]); 

    const del = async (id) => {
        let tmp = JSON.parse(JSON.stringify(contextProducts))
        let idx = tmp.findIndex((fel) => fel.id === id)
        if (idx > -1) {tmp.splice(idx, 1)}
        setContextProducts(tmp)
    }
    const handleClickDelProduct = (item) => {
        ShowModal('Удалить товар', 
        <div>Вы уверены, что хотите удалить товар?</div>, 
        async () => {
            try {
            del(item)
            }
            catch (err) {}
            finally {}
            
        });
    }


    console.log("contextProducts", contextProducts)
    console.log("data", data)
    console.log("dist", dist)
    console.log("newMarket", newMarket)

    if (loading) {
        return <Loading></Loading>
    }

    return (
        <Box height="100%" width={"100%"} display="flex" flexDirection="column" >
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '620px', width: '1420px', padding: '12px' }}>
                    {/* <AddProducts navigateDeal={false} cancel={setOpen}></AddProducts> */}
                    <AddMoreProductToNewDeal old={contextProducts} cancel={setOpen}></AddMoreProductToNewDeal>
                </div>
            </Dialog>
            <Dialog
                open={openCopy}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenCopy(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <SelectProductTocopy data={contextProducts.filter((el) => el.id !== copyData?.row?.id)} cancel={setOpenCopy} onCopy={(list) => {copyTechTask(list)}}></SelectProductTocopy>
                </div>
            </Dialog>
             <Box 
                sx={{
                    width: "98%",
                    height: '15%',
                    margin: "1% 1% 0% 1%",
                    display:'flex', 
                    flexDirection:'row', 
                    gap:2, 
                    padding: "1%",
                    backgroundColor:'white',
                    borderTopLeftRadius: "10px",
                    borderTopRightRadius: "10px"
                }}
            >
                <div style={{display:'flex', flexDirection:'row', gap: '20px'}}>
                    <div style={{display: "flex", flexDirection:"column", gap: "2px"}}>
                        <TextInputDesign title={"Транзитный склад:"} val={warehouse_tranzit} onChange={(v) => setwarehouse_tranzit(v)}/>
                        <TextInputDesign title={"Склад назначения:"} val={warehouse_market} onChange={(v) => setWarehouse_market(v)}/>
                        <div style={{display:'flex', flexDirection:'row', alignContent:'center', alignItems:'center', marginTop:"2px"}}>
                            <span style={{marginRight: "5px"}}>Дата отгрузки: </span>
                            <DateMenu date={date_shipment} onChange={setDate_shipment}/>
                        </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center"}}>
                        <Divider orientation="vertical" sx={{ borderRightWidth: "3px", height:"95%" }} />
                    </div>
                    <div style={{display: "flex", flexDirection:"column", gap: "2px"}}>
                        <span>Количество товара: {allProduct}</span>
                        <span>SKU: {allSKU}</span>
                    </div>
                </div>
                <div style={{display:'flex', flexDirection:'row', alignContent:'center', alignItems:'center', justifyContent: "space-around", marginRight: "15px"}}>
                    <div style={{marginRight: "5px"}}>
                        <ImgMagazine magazine={oldMarket} size={30} user_id={user_id}/>
                    </div>
                    <TrendingFlatIcon style={{ color: "#078376" }}/>
                    <SelectMarketLocal markets={["wb", "ozon", 'custom']} market={newMarket} save={(m) => {setNewMarket(m)}} size={30} user_id={user_id}/>
                </div>
            </Box>
            <div style={{
                width: '98%', 
                height: '77%',
                margin: "0% 1% 1% 1%",
                backgroundColor:'white',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px"
            }}>
                <Scrollbars
                    style={{ width: '100%', height: '100%', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                >
                    <ReportTable 
                        ds={ds} 
                        data={contextProducts} 
                        onFormatterChange={changeRow}
                        aditionalAction={
                            [
                                {
                                    action: (item) => {handleClickDelProduct(item.id)},
                                    ui: () => {return (
                                        <DeleteForeverIcon
                                            sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                            }}
                                        />
                                    )}
                                }
                            ]
                        }
                    >
                    </ReportTable>
                </Scrollbars>
            </div>
            <Box height="5%" display="flex" justifyContent="right" alignItems="center" px={2} sx={{marginBottom: "1%"}}>
                <Button variant="contained" onClick={() => { setOpen(true) }}
                    disabled={loadingCreate}
                    sx={{ textTransform: 'none', marginRight: '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Добавить товар
                </Button>
                <Button variant="contained"
                    onClick={preventDoubleClick(create, 1000)}
                    disabled={loadingCreate}
                    sx={{ textTransform: 'none', marginRight: loadingCreate? "0px": '10px', backgroundColor: colors.elements, fontWeight: 'bold' }} >
                    Создать поставку
                </Button>
                {loadingCreate && <Loading></Loading>}
            </Box>
        </Box>

    );
}

function AddMoreProductToNewDeal({old, cancel}) {
    /** @type {[Array<any>, Function]} */
    const [$data, setData] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [selected, setSelected] = useState([]);        
    const ds = useMemo(() => getDataSource('ProductsForNewDeal'), []);
    
    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
            size: {name: "Размер", active: true},
        }
    );

    const [stat, setStat] = useState(undefined);
    
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const navigate = useNavigate();
    /** @type {any} */
    const { setContextData } = useDataContextDeal();
    const [loading, setLoading] = useState(true);
    
    const onSelect = (select) => {
        console.log("onSelect", select)
        setSelected(select);
    };

    const { user_id} = useSelector(
          loginSelector
      );
    const { market } = useSelector(MarketClientSelector);

    const [newMarket, setNewMarket] = useState(market);

    useEffect(() => {
        const fetchData = async () => {
    
            try {
              setLoading(true);
              let responseData = undefined
              switch(newMarket){
                case "wb": 
                    responseData = await get('WBAPI/GetProductStocksInStorage', {uid:user_id});
                    break
                case "ozon": 
                    responseData = await get('OZONAPI/GetProductStocksInStorage', {uid:user_id});
                    break
                case "custom":
                    responseData = await get("custom_product/get_product_stocks_in_storage", {cid:user_id})
                    break;
              }
              //let responseData = await get('WBAPI/GetProductStocksInStorage', {uid:user_id});
              let res = []
              responseData.map((el) => {
                if (el.countProduct > 0) {
                    //Проверяем одинакова ли упаковка
                    //Просто сравнить не можем из-за fromDeal
                    let err = false//Флаг ошибки
                    let pkgList = undefined
                    let consList = undefined
                    let consAdditList = undefined
                    let lvl1keys = Object.keys(el.distribution)
                    for (let k1 of lvl1keys) {
                        let lvl2keys = Object.keys(el.distribution[k1])
                        for (let k2 of lvl2keys) {
                            if (el.distribution[k1][k2].package) {
                                let pkgListLocal = []
                                for (let pkg of el.distribution[k1][k2].package) {
                                    let pkgidx = pkgListLocal.findIndex((fel) => fel.id === pkg.id)
                                    if (pkgidx > -1) {
                                        if (pkgListLocal[pkgidx].count !== pkg.count) {
                                            err = true
                                            break
                                        }
                                    }
                                    else {
                                        pkgListLocal.push({id: pkg.id, count: pkg.count})
                                    }
                                }
                                if (pkgList) {
                                    if (!_.isEqual(pkgList, pkgListLocal)) {
                                        err = true
                                        break
                                    }
                                }
                                else {
                                    // @ts-ignore
                                    pkgList = [].concat(pkgListLocal)
                                }
                            }
    
                            if (el.distribution[k1][k2].consumes) {
                                let consListLocal = []
                                for (let cons of el.distribution[k1][k2].consumes) {
                                    let considx = consListLocal.findIndex((fel) => fel.id === cons.id)
                                    if (considx > -1) {
                                        if (consListLocal[considx].count !== cons.count) {
                                            err = true
                                            break
                                        }
                                    }
                                    else {
                                        consListLocal.push({id: cons.id, count: cons.count})
                                    }
                                }
                                if (consList) {
                                    if (!_.isEqual(consList, consListLocal)) {
                                        err = true
                                        break
                                    }
                                }
                                else {
                                    // @ts-ignore
                                    consList = [].concat(consListLocal)
                                }
                            }

                            if (el.distribution[k1][k2].addit_cons) {
                                let consAdditListLocal = []
                                for (let cons of el.distribution[k1][k2].addit_cons) {
                                    let considx = consAdditListLocal.findIndex((fel) => fel.id === cons.id)
                                    if (considx > -1) {
                                        if (consAdditListLocal[considx].count !== cons.count) {
                                            err = true
                                            break
                                        }
                                    }
                                    else {
                                        consAdditListLocal.push({id: cons.id, count: cons.count})
                                    }
                                }
                                if (consAdditList) {
                                    if (!_.isEqual(consAdditList, consAdditListLocal)) {
                                        err = true
                                        break
                                    }
                                }
                                else {
                                    // @ts-ignore
                                    consAdditList = [].concat(consAdditListLocal)
                                }
                            }
    
                            if (err) {break}
                        }
                        if (err) {break}
                    }
                    console.log("test", el)
                    el.countInfo = {count:el.countProduct, inBox: el.inbox, err}
                    el.storage_count = el.countProduct
                    res.push(el)
                }            
              })
              res.map((el) => {
                console.log(el)
                let testidx = old.findIndex((fel) => 
                    fel.nmID === el.nmID && 
                    fel.size.barcode === el.size.barcode && 
                    fel.id !== el.id
                )
                let idx = old.findIndex((fel) => fel.id === el.id)
                console.log("idx", idx)
                console.log("testidx", testidx)
                if (idx > -1 && testidx === -1) {
                    //Такой товар найден в уже добавленных и нету его аналогов
                    //Просто убавляем его количество 
                    el.countProduct -= old[idx].countProduct
                    el.countInfo.count -= old[idx].countProduct
                    el.storage_count -= old[idx].countProduct
                }
                if (idx === -1 && testidx > -1) {
                    //Такой товар найден в уже добавленных и нету его аналогов
                    //Просто убавляем его количество 
                    el.countProduct = 0
                    el.countInfo.count = 0
                    el.storage_count
 = 0
                }
                el.data.color = el.color
                el.data.vendorCode = el.vendorCode
                el.data.barcode = el.size.barcode
                el.data.sizeTitle = el.size.title
                
              })
              setData(res.filter((el) => el.countProduct > 0))
            } catch (err) {
            } finally {
            setLoading(false);
            }
    
            
        };   
        
        fetchData();
      }, []); 

    const onChangeCount = (idata) => {
        let tmp = [...$data]
        let idx = tmp.findIndex((el) => el.id === idata.row.id)
        if (idx > -1) {
            tmp[idx].countProduct = idata.count
            setData(tmp)
        }

    }

    const goBind = async () => {
        let tmp = JSON.parse(JSON.stringify($data))
        if (selected.length>0) {
            
            let res = []
            for (let sel of selected) {
                let idx = tmp.findIndex((el) => el.id === sel)
                if (idx > -1 ) {
                    if (tmp[idx].countProduct > 0) {
                        res.push({...tmp[idx]})
                    }
                    else {
                        showNotification({
                            id: 'binderr', 
                            type: 'error', 
                            message: 'У товара не указано количество' 
                        });        
                        return 1
                    }
                }
                
            }

            let checkList = []
            let err = false
            let errCount = undefined
            for (let p of res) {
                let tmp = `${p.nmID}:${p.size.barcode}`
                if (checkList.includes(tmp)) {
                    err = true
                    break
                }
                checkList.push(tmp)
                if (p.countProduct > p.storage_count) {
                    errCount = `Превышено количество товара ${p.size.barcode}`
                    break
                }
            }
            if (err) {
                showNotification({
                    id: 'err', 
                    type: 'error', 
                    message: 'Нельзя выбирать одинаковый товар с разным тезническим заданием' 
                });   
                return
            }
            if (errCount) {
                showNotification({
                    id: 'err', 
                    type: 'error', 
                    message: errCount
                });   
                return
            }
            
            setContextData({ deal: res });
            cancel(false);
        }
        else {
            showNotification({
                id: 'binderr', 
                type: 'error', 
                message: 'Ни один товар не выбран' 
            });
        }
    }

    // useEffect(() => {
    //     setData(data.map((el) => {return {...el}}))
    // }, [data]);

    console.log("data", $data)

    if (loading) {
        return <Loading></Loading>
    }

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
                overflow: "hidden"
            }}
        >
            {/* Заголовок */}

            <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "text.primary",

                }}
            >
                {`${ds.descr.title}`}
            </Typography>

            {/* Поле поиска */}
            <Box sx={{ width: "50%" }}>
                <ClassicSearch 
                    setChecked={setChecked} 
                    setFilter={setFilter} 
                    checked={checked}
                    // @ts-ignore
                    fields={filterFields}
                    // @ts-ignore
                    setFields={setFilterFields}
                />
            </Box>

            {/* Таблица с прокруткой */}
            <div style={{display:"flex", flexDirection: 'row', height: "100%"}}>
                <Box
                    sx={{
                        flex: 1,
                        overflow: "auto",
                        borderRadius: 2,
                        width: "60%"
                    }}
                >
                    <Scrollbars autoHide>
                        <ReportTable
                            ds={ds}
                            data={!checked? sortProducts($data): sortProducts($data.filter((el) => {const tf = filter.toLowerCase(); 
                                return (
                                    filterFields.title.active && 
                                        el.title &&
                                        String(el.title).toLowerCase().includes(tf) || 
                                    filterFields.brand.active && 
                                        el.brand && 
                                        String(el.brand).toLowerCase().includes(tf) || 
                                    filterFields.vendorCode.active && 
                                        el.vendorCode &&
                                        String(el.vendorCode).toLowerCase().includes(tf) || 
                                    filterFields.color.active && 
                                        el.color &&
                                        el.color.join('').toLowerCase().includes(tf) ||
                                    filterFields.size.active &&
                                            el.size.title &&
                                            String(el.size.title).toLowerCase().includes(tf) ||
                                    filterFields.barcode.active && 
                                        el.size.barcode &&
                                        String(el.size.barcode).toLowerCase().includes(tf) 
                                )}))}
                            onSelect={onSelect}
                            onFormatterChange={onChangeCount}
                            onClickRow={(item) => {setStat({total: item.total, totalInRoad: item.totalInRoad})}}
                        />
                    </Scrollbars>
                </Box>
            </div>
            

            {/* Нижняя панель с кнопками и полем ввода */}
            <Box

                sx={{
                    mt: 'auto',
                    p: 1,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    borderRadius: 2,
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "100%",
                        justifyContent: 'space-between',
                    }}
                >
                    <Button 
                        onClick={() => cancel(false)}    
                        variant="text" 
                        sx={{ 
                            height: "35px", 
                            width: "150px", 
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            fontSize: "20px",
                            borderRadius: "10px"
                        }}
                    >
                        {"Отмена"}
                    </Button>
                    <Button 
                        onClick={preventDoubleClick(goBind, 1000)}
                        variant="contained" 
                        sx={{ 
                            height: "35px", 
                            width: "150px", 
                            textTransform: 'none', 
                            fontWeight: 'bold', 
                            marginBottom: '10px',
                            marginTop: '10px',
                            fontSize: "20px",
                            borderRadius: "10px"
                        }}
                    >
                        Добавить
                    </Button>
                    
                </Box>
            </Box>
        </Box>
    );
}